import type { Organization } from "@/models/organization"
import type { Site } from "@/models/site"
import { INTERVAL_USAGE_LIST_FILTERS } from "@/services/interval/interval-utils"

interface IntervalRecordsExportQuery {
  end: string | undefined
  format?: "csv" | "xlsx"
  meterIds: string
  siteId: Site["id"]
  sort?: string
  start: string | undefined
}

export const buildIntervalRecordsExportPath = (
  organizationId: Organization["id"],
  query: IntervalRecordsExportQuery
): string | undefined => {
  if (
    !organizationId ||
    !query.siteId ||
    !query.start ||
    !query.end ||
    query.meterIds.length === 0
  ) {
    return undefined
  }

  const params = new URLSearchParams({
    end: query.end,
    format: query.format ?? "csv",
    measurement_types: INTERVAL_USAGE_LIST_FILTERS.measurement_types,
    meter_ids: query.meterIds,
    site_id: query.siteId,
    start: query.start,
  })
  if (query.sort) {
    params.set("sort", query.sort)
  }

  return `/api/v1/organizations/${organizationId}/intervals/export?${params.toString()}`
}
